import { updateCourse } from "@/api/new-api/staff-management/menu-manage/special-menu/course";
import { createSlice } from "@reduxjs/toolkit";
import toast from "react-hot-toast";
import { v4 } from "uuid";
import { isSameCourseItem } from "@/lib/banquetPriceUtils";


const selectedItemSlice = createSlice({
  name: "SelectedItem",
  initialState: {
    isSelected: false,
    id: null,
    quantity: 0,
    data: null,
    extraAddon: [],
    modifiers: [],
    extraToppings: [],
    extraSalads: [],
    extraSauces: [],
    selectedCourseItem: [],
    selectedMixAndMatchItems: [],
    buffetPriceFor: "Adult",
    showCartDetails: false
  },
  reducers: {
    setSelectedItem: (state, action) => {
      if(action?.payload?.item?.menu_item_id == 16 || action?.payload?.item?.menu_item_id == 21){

        console.log("Selected Course-based Item:", action?.payload);

        state.id = v4();
        state.isSelected = true;
        state.data = action.payload;
        state.quantity = 0;
        state.selectedMixAndMatchItems = [];

        if(!action?.payload?.item?.courses || action?.payload?.item?.courses.length > 0){
          const defaultSelectedItems = action?.payload?.item?.courses?.map(course => ({
            ...course,
            course_items: course?.course_items?.slice(0, course?.max_selections)
          }));


          state.selectedCourseItem = defaultSelectedItems;

          console.log("Default Selected Course Items:", defaultSelectedItems);
        }

        return state;
      }

      state.isSelected = true;
      state.data = action.payload;
      state.id = v4();
      state.quantity = 0;
      state.extraAddon = [];
      state.modifiers = [];
      state.extraToppings = [];
      state.extraSalads = [];
      state.extraSauces = [];
      state.selectedCourseItem = [];
      state.selectedMixAndMatchItems = action.payload?.selectedMixAndMatchItems || [];
      state.buffetPriceFor = "Adult";
      state.showCartDetails = action.payload.showCartDetails || false;
      return state;

    },
    setSelectedItemFromCart: (state, action) => {
      const payload = { ...action.payload };
      const menuItemId = Number(payload?.data?.item?.menu_item_id || payload?.item?.menu_item_id || payload?.menu_item_id);
      const isCourseBased = menuItemId === 16 || menuItemId === 21;
      
      if (isCourseBased) {
        const courses = payload?.data?.item?.courses || payload?.item?.courses || [];
        if (Array.isArray(courses) && courses.length > 0) {
          if (!payload.selectedCourseItem || payload.selectedCourseItem.length === 0) {
            payload.selectedCourseItem = courses.map(course => ({
              ...course,
              course_items: Array.isArray(course?.course_items) ? course.course_items.slice(0, course?.max_selections || 1) : []
            }));
          } else {
            courses.forEach(dc => {
              const exists = payload.selectedCourseItem.some(c => String(c.id) === String(dc.id));
              if (!exists) {
                payload.selectedCourseItem.push({
                  ...dc,
                  course_items: []
                });
              }
            });
          }
        }
      }
      return payload;
    },
    cancelSelectedItem: (state) => {
      state.isSelected = false;
      state.data = null;
      state.quantity = 0;
      state.id = null,
      state.extraAddon = [];
      state.modifiers = [];
      state.extraToppings = [];
      state.extraSalads = [];
      state.extraSauces = [];
      state.selectedCourseItem = [];
      state.selectedMixAndMatchItems = [];
      state.buffetPriceFor = "Adult";
      state.showCartDetails = false;
      return state;
    },
    setSelectedItemQuantity: (state, action) => {
      state.quantity = action.payload;
    },
    changeSelectedBuffetPriceFor: (state, action) => {
      state.buffetPriceFor = action.payload;
    },
    updateCourseItem: (state, action) => {
      const definedCourses = state.data?.item?.courses || state.data?.courses || [];
      if (!Array.isArray(state.selectedCourseItem)) {
        state.selectedCourseItem = [];
      }
      if (Array.isArray(definedCourses) && definedCourses.length > 0) {
        definedCourses.forEach(dc => {
          const exists = state.selectedCourseItem.some(c => String(c.id) === String(dc.id));
          if (!exists) {
            state.selectedCourseItem.push({
              ...dc,
              course_items: []
            });
          }
        });
      }

      state.selectedCourseItem = state.selectedCourseItem.map(course => {
        if(String(course?.id) === String(action.payload.courseId)){

          const isItemAlreadySelected = course?.course_items?.some(item => 
            isSameCourseItem(item, action.payload.item)
          );

          if(isItemAlreadySelected){
            // remove item from course
            course.course_items = course?.course_items?.filter(item => 
              !isSameCourseItem(item, action.payload.item)
            );
          }else{
            const rawItem = action.payload.item;
            const newItem = {
              ...rawItem,
              course_item_unique_id: rawItem.course_item_unique_id || rawItem.unique_id || v4(),
              extraAddon: rawItem.extraAddon || [],
              modifiers: rawItem.modifiers || [],
              extraToppings: rawItem.extraToppings || [],
              extraSauces: rawItem.extraSauces || [],
              extraSalads: rawItem.extraSalads || [],
              defaultAddons: rawItem.defaultAddons || rawItem.menu_item?.add_ons?.map(a => ({ ...a, canceled: false })) || [],
              defaultSauces: rawItem.defaultSauces || rawItem.menu_item?.sauces?.map(s => ({ ...s, canceled: false })) || [],
              defaultSalads: rawItem.defaultSalads || rawItem.menu_item?.salads?.map(s => ({ ...s, canceled: false })) || [],
              defaultToppings: rawItem.defaultToppings || rawItem.menu_item?.toppings?.map(t => ({ ...t, canceled: false })) || []
            };

            if (course.max_selections === 1 && course.course_items.length === 1) {
              course.course_items = [newItem];
            } else if (course.max_selections && course.course_items.length >= course.max_selections) {
              toast.error(`You can select up to ${course.max_selections} items for the course "${course.name}".`);
            } else {
              course.course_items = [...course.course_items, newItem];
            }
          }
          return course;
        }

        return course;
      });
      return state;
    },
    updateMixAndMatchSelection: (state, action) => {
      const { categoryId, categoryName, categoryPrice, item, delta = 1, maxChoose = 1 } = action.payload;
      const itemId = item?.id !== undefined ? item?.id : (item?.name || item);
      const itemName = item?.name || item;

      let currentList = state.selectedMixAndMatchItems ? [...state.selectedMixAndMatchItems] : [];
      const totalSelected = currentList.reduce((sum, it) => sum + (Number(it.quantity) || 1), 0);

      const existingIndex = currentList.findIndex(
        (it) =>
          (String(it.category_id) === String(categoryId) || (it.category_name && categoryName && String(it.category_name).toLowerCase().trim() === String(categoryName).toLowerCase().trim())) &&
          (String(it.item_id) === String(itemId) || (it.item_name && itemName && String(it.item_name).toLowerCase().trim() === String(itemName).toLowerCase().trim()) || (it.name && itemName && String(it.name).toLowerCase().trim() === String(itemName).toLowerCase().trim()))
      );

      if (delta > 0) {
        if (totalSelected >= maxChoose) {
          toast.error(`You can select a maximum of ${maxChoose} item(s) for this Mix & Match.`);
          return state;
        }
        if (existingIndex !== -1) {
          currentList[existingIndex].quantity = (Number(currentList[existingIndex].quantity) || 1) + delta;
        } else {
          currentList.push({
            category_id: categoryId,
            category_name: categoryName,
            category_price: Number(categoryPrice) || 0,
            item_id: itemId,
            item_name: itemName,
            quantity: 1
          });
        }
      } else if (delta < 0) {
        if (existingIndex !== -1) {
          const currentQty = Number(currentList[existingIndex].quantity) || 1;
          if (currentQty + delta <= 0) {
            currentList.splice(existingIndex, 1);
          } else {
            currentList[existingIndex].quantity = currentQty + delta;
          }
        }
      }
      state.selectedMixAndMatchItems = currentList;
      return state;
    }
  },

});

export const { setSelectedItem, cancelSelectedItem, setSelectedItemQuantity, setSelectedItemFromCart, changeSelectedBuffetPriceFor, updateCourseItem, updateMixAndMatchSelection } = selectedItemSlice.actions;

export default selectedItemSlice.reducer;
